import { render, staticRenderFns } from "./TicketDefectsExpansionPanel.vue?vue&type=template&id=9a916f96&"
import script from "./TicketDefectsExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./TicketDefectsExpansionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports